module.exports = __webpack_public_path__ + "img/arrow-right-modal.194b26f3.svg";